// features/event/eventApiSlice.js
import { apiSlice } from './apiSlice'; // Ensure apiSlice is correctly set up and imported
const EVENTS_URL = '/api/events';

export const eventsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all events
    getEvents: builder.query({
      query: () => ({
        url: EVENTS_URL,
        method: 'GET',
      }),
      providesTags: ['Event'],
    }),
    getLeagueEvents: builder.query({
      query: ({ leagueId, page = 1, limit = 20 }) => `${EVENTS_URL}/league/${leagueId}?page=${page}&limit=${limit}`,
      providesTags: (result, error, { leagueId }) => [{ type: 'Event', id: `league-${leagueId}` }],
    }),
    // Fetch a single event by ID
    getEventById: builder.query({
      query: (id) => ({
        url: `${EVENTS_URL}/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Event', id }],
    }),
    // Create a new event
    createEvent: builder.mutation({
      query: (newEvent) => ({
        url: EVENTS_URL,
        method: 'POST',
        body: newEvent,
      }),
      invalidatesTags: ['Event', 'Athletes'],
    }),
    // Update an existing event
    updateEvent: builder.mutation({
      query: ({ id, ...updatedEvent }) => ({
        url: `${EVENTS_URL}/${id}`,
        method: 'PUT',
        body: updatedEvent,
      }),
      invalidatesTags: ['Event', 'Athletes'],
    }),
    updateEventClassification: builder.mutation({
      query: ({ id, ...classification }) => ({
        url: `${EVENTS_URL}/${id}/classification`,
        method: 'PUT',
        body: classification,
      }),
      invalidatesTags: ['Event', 'Athletes', 'Leagues'],
    }),
    // Delete an event
    deleteEvent: builder.mutation({
      query: (request) => ({
        url: `${EVENTS_URL}/${typeof request === 'object' ? request.id : request}${typeof request === 'object' && request.leagueId ? `?leagueId=${request.leagueId}` : ''}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Event', 'Athletes'],
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetLeagueEventsQuery,
  useGetEventByIdQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useUpdateEventClassificationMutation,
  useDeleteEventMutation,
} = eventsApiSlice;
